<template>
  <!-- 半屏的供应商ISBN批量下单页面   class="container" -->
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>通用批量查询</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 0px;">
      <el-col :span="24" style="margin-top: -14px; margin-bottom: 6px;">
        <span style="color: red; font-size: 14px;">说明：</span>
        <span style="color: #67c23a; font-size: 14px;">
          <br>只能上传Excel文件，表头必须包含ISBN或书名。导入数据量越大，请耐心等待。
          <br>
        </span>
      </el-col>
      <el-col :span="4">
        <el-upload action="no" :limit="1" :on-remove="changeFileLength" :on-change="changeFileLength"
          class="upload-demo" ref="upload" :auto-upload="false" :http-request="uploadOk">
          <el-button :disabled="selectFileBtnFlag" size="small" icon="el-icon-upload2"
            type="primary">上传下单书目文件</el-button>
        </el-upload>
      </el-col>
      <!-- <el-col :span="8">
        <el-button size="small" icon="el-icon-share" @click="selectSupplierClickHander" type="warning">选择供货商( <b
            style="color: black;font-size: 12px;">{{ selectSupplierList.length }}</b> )</el-button>
        <el-button size="small" icon="el-icon-share" @click="selectPrioritySupplierClickHander"
          type="warning">优先供货商( <b style="color: black;font-size: 12px;">{{
            selectPrioritySupplierList.length }}</b> )</el-button>
      </el-col> -->
      <el-col :span="8">
        <el-select v-model="whGroups" size="small" style="width:90%" multiple placeholder="请选择供应商分组">
          <el-option v-for="item in whGroupOption" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <!-- <el-input size="small" style="width:280px" v-model="productNumGe">
          <template slot="prepend">供应商分组</template>
        </el-input> -->
        <span style="color: red; font-size: 14px;margin-left: 0px; display: block;">多选供应商分组，查询这其中供应商的库存数据</span>
      </el-col>
      <el-col :span="6">
        <el-input size="small" style="width:180px" v-model="productNumGe">
          <template slot="prepend">副本数量 >=</template>
        </el-input>
        <span style="color: red; font-size: 14px;margin-left: 0px; display: block;">会统一覆盖掉Excel里的预购数量</span>
      </el-col>
      <el-col :span="6">
        <el-input size="small" style="width:180px" v-model="productNumBuff">
          <template slot="prepend">数量增幅</template>
        </el-input>
        <span style="color: red; font-size: 14px;margin-left: 0px; display: block;">优先按照增幅后的库存进行匹配</span>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-button :disabled="uploadFileBtnFlag" size="small" icon="el-icon-share" type="success"
          @click="matchProductAuto">匹配查询</el-button>
      </el-col>
      <!-- <el-col :span="24" >
        <div v-for="(item, i) in batchMesageList" :key="i">
          <span style="color: red; font-size: 12px;" v-if="item && item.length > 0">
            {{ item }}
          </span>
        </div>
      </el-col> -->
      <el-col :span="24">
        <div v-for="(item, i) in whBatchAutoMsgList" :key="i">
          <span style="color: red; font-size: 12px;" v-if="item && item.msg">
            [{{ item.msgTime }}] {{ item.msg }}
          </span>
        </div>
      </el-col>
    </el-row>

    <el-card class="box-card">
      <div slot="header" class="clearfix" style="margin: -10px auto;">
        <span>匹配成功商品清单</span>
        <el-button v-if="searchEnd || tableData.length > 0" style="margin-left: 20px;" size="mini" icon="el-icon-download"
          type="success" @click="matchProductAllExport">导出全部匹配数据</el-button>
      </div>
      <div>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pagesize" layout="total,prev,pager,next" :total="pageTotal">
        </el-pagination>
      </div>
      <el-row>
        <el-col :span="24">
          <div>
            <el-table v-loading="loading" :data="tableData" size="small" @selection-change="handleSelectionChange"
              element-loading-text="正在匹配商品中，请稍后。。。" ref="multipleTable" tooltip-effect="dark" style="width: 100%">
              <el-table-column type="selection" align="center" width="55" />
              <el-table-column label="供应商" width="120">
                <template slot-scope="scope">
                  {{ scope.row.warehouseCode ? scope.row.warehouseUserName : scope.row.supWarehouseCode }}
                </template>
              </el-table-column>
              <el-table-column label="图书名称" align="center" prop="productName" />
              <el-table-column align="center" label="ISBN" width="180" prop="productSn" />
              <el-table-column label="来源库" align="center" prop="discount" width="100">
                <template slot-scope="scope">
                  <div style="color:green;" v-if="scope.row.productSource === '0'">系统库</div>
                  <div style="color:saddlebrown;" v-else>供应商自己库</div>
                </template>
              </el-table-column>
              <el-table-column label="折扣价" prop="shopPrice" width="100" align="center">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.shopPrice }}</div>
                </template>
              </el-table-column>
              <el-table-column label="折扣" align="center" prop="discount" width="90" />
              <el-table-column label="定价" prop="marketPrice" width="100" align="center">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.marketPrice }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="searchBuyNum" align="center" width="100" label="预购" />
              <el-table-column prop="buyNum" align="center" width="100" label="购买数量" />
              <el-table-column prop="productNum" label="库存数量" width="100" align="center" />
              <!-- <el-table-column align="center" width="100" label="剩余">
                <template slot-scope="scope">
                  <div v-if="scope.row.productNum >= scope.row.buyNum">{{scope.row.productNum - scope.row.buyNum}}</div>
                  <div v-else>0</div>
                </template>
              </el-table-column> -->
            </el-table>
            <div style="margin-top: 10px">
              <el-button type="primary" :disabled="!selectSystemFlag" icon="el-icon-shopping-cart-2"
                style="width: 130px; float:right;" @click="addCartSelect">加入购物车</el-button>
              <el-button type="primary" :disabled="!(tableData.length > 0 && selectSystemFlag)"
                icon="el-icon-shopping-cart-2" style="float:right;margin-right: 10px;"
                @click="addCartAll">全部加入购物车</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <div class="page">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
          layout="total,prev,pager,next" :total="pageTotal">
        </el-pagination>
      </div> -->
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix" style="margin: -10px auto;">
        <span>匹配失败商品清单</span>
        <!-- <el-button v-if="tableData1 && tableData1.length > 0" style="margin-left: 20px;" size="mini"
          icon="el-icon-search" type="danger" @click="matchProductAutoTwo">失败重新匹配</el-button> -->
      </div>
      <div>
        <el-pagination background @current-change="handleCurrentErrorChange" :current-page="errPage.currentPage"
          :page-size="errPage.pagesize" layout="total,prev,pager,next" :total="errPage.pageTotal">
        </el-pagination>
      </div>
      <el-row>
        <el-col :span="24">
          <div>
            <el-table ref="multipleTable" :data="tableData1" tooltip-effect="dark" style="width: 100%" size="small">
              <el-table-column prop="productSn" label="ISBN" width="160" />
              <el-table-column prop="productName" label="书名" width="360" />
              <el-table-column prop="buyNum" label="数量" />
              <el-table-column prop="marketPrice" label="定价" />
              <el-table-column prop="author" label="作者" />
              <el-table-column prop="providerName" label="出版社" />
              <!-- <el-table-column prop="discount" label="折扣"/>
              
              <el-table-column prop="warehouseCode" label="供货商"/> -->
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog width="90%" :title="selectLabel === 1 ? '选择供货商':'优先供货商'" :visible.sync="dialogTableVisible">
      <el-form ref="form" label-width="100px" size="small">
        <el-row>
          <!-- 选择供货商 -->
          <el-checkbox-group v-show="selectLabel == 1" v-model="selectSupplierList"
            @change="selectSupplierChangeHandler">
            <el-col :span="4" v-for="(item) in dataSupplierList" :key="item.id">
              <!-- <el-tooltip class="item" effect="dark" :content="item.warehouseName" open-delay="500"> -->
              <el-checkbox :label="item.id" :title="item.warehouseName">
                {{ item.userName }} ({{ item.warehouseCode }})
              </el-checkbox>
              <!-- </el-tooltip> -->
            </el-col>
          </el-checkbox-group>
          <!-- 选择优先供货商 -->
          <el-checkbox-group v-show="selectLabel == 2" v-model="selectPrioritySupplierList">
            <el-col :span="4" v-for="(item, index) in dataPrioritySupplierList" :key="index">
              <el-checkbox :label="item.id" :title="item.warehouseName">
                {{ item.userName }} ({{ item.warehouseCode }})
              </el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" :disabled="confirmLoading" @click="onCommitSelect">确定</el-button> -->
        <el-button @click="selectAllWh(1)" v-if="selectAllFlag">全选</el-button>
        <el-button @click="selectAllWh(0)" v-else>全不选</el-button>
        <el-button @click="dialogTableVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { downFile, getAction, postAction } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "batchOrderAuto",
  data() {
    return {
      tableData: [], // 匹配成功的table
      tableData1: [], // 匹配失败的table
      errorAllList: [], // 所有匹配失败的数据
      searchWHList: [],
      matchingInfo: {}, // 匹配记录信息
      loading: false,
      searchEnd: false,
      selectProductList: [],
      fileList: [],
      fileName: "",
      uploadForm: {
        productNumGe: 0,
        fileList: [],
      },
      currentPage: 1, // 当前页码
      pagesize: 20, // 每页显示的行数
      pageTotal: 0,
      errPage:{
        currentPage: 1, // 当前页码
        pagesize: 10, // 每页显示的行数
        pageTotal: 0,
      },
      url: {
        matchWHProductExeclByAync: "/whBatchOrder/matchWHProductExeclByAync",
        matchWHProductJson: "/whBatchOrder/matchWHProductJsonByAync",
        matchWHProductExport: "/whBatchOrder/matchWHProductExport",
        addWHCart: "/cart/wh/addcart",
        queryCartWHList: "/cart/wh/queryCartWHList",
        matchWHProductErrorDataPage: "/whBatchOrder/matchWHProductErrorDataPage", // 分页
        matchWHProductSuccessDataPage: "/whBatchOrder/matchWHProductSuccessDataPage", // 分页
        queryWHCustomerSupplierList: "/whBatchOrder/queryWareHouseList",// 供应商导入的供货商信息列表
        getWhGroupList: "/common/whQueryGroupSelectlist",
      },
      searchType: 'auto', // “isbn”， “productName” "other"
      whGroups: [],
      productNumGe: 0,
      productNumBuff: 0,
      batchNumber: '', // 批次号
      filesLength: 0, // 文件长度
      BSfileList: [], // 选择文件集合
      selectFileBtnFlag: false,
      uploadFileBtnFlag: true,
    
      confirmLoading: false,
      dialogTableVisible: false, // dialog
      selectSystemFlag: true, // 选择系统库
      selectLabel: 1, // 1：选择供货商，2：选择优先供货商
      selectSupplierList: [],  // 选择供货商列表(选中的值)
      selectPrioritySupplierList: [],  // 选择优先供货商列表 (选中的值)
      dataSupplierList: [],  // 选择供货商列表(要选择的数据)
      dataPrioritySupplierList: [],  // 选择优先供货商列表(要选择的数据)
      selectAllFlag: true,
      selectAll1Flag: true,
      selectAll2Flag: true,
      batchMesageList: [],
      timerObj: null,
      whGroupOption: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters(["isNaName"]),
    whBatchAutoMsgList() {
      return this.$store.state.socket.whBatchAutoMsgList
    },
    whBatchAutoEnd() {
      return this.$store.state.socket.whBatchAutoEnd
    },
  },
  watch: {
    whBatchAutoMsgList: {
      handler(newValue) {
        // console.log("whBatchAutoMsgList", newValue)
        if(newValue){
          // this.handlerSocketMessage()
        }
      },
      immediate: true,
      deep: true,
    },
    whBatchAutoEnd: {
      handler(newValue) {
        // console.log("whBatchAutoEnd", newValue)
        if (newValue) {
          // 显示导出按钮
          this.searchEnd = true

          this.getBatchOrder()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() { 
  },
  mounted() {
    this.getBatchOrder()

    this.getDataSupplierList()
    this.getWhgroupList()
  },
  methods: {
    getWhgroupList() {
      getAction(this.url.getWhGroupList, {}).then((res) => {
        if (res.data.success) {
          this.whGroupOption = res.data.result;
        }
      });
    },
    selectAllWh(a){
      const that = this
      if(that.selectLabel == 1){ // 选择供货商
        if(a == 1){
          var arr1=[]
          if(that.dataSupplierList && that.dataSupplierList.length > 0){
            that.dataSupplierList.forEach(element => {
              arr1.push(element.id)
            });
          }
          that.selectSupplierList = arr1
        } else if(a == 0) {
          that.selectSupplierList = []
          that.selectPrioritySupplierList = []
        }
        that.selectSupplierChangeHandler(that.selectSupplierList)
        that.selectAll1Flag = !that.selectAll1Flag
      } else if(that.selectLabel == 2){ // 选择优先供货商
        if(a == 1){
          var arr=[]
          if(that.dataPrioritySupplierList && that.dataPrioritySupplierList.length > 0){
            that.dataPrioritySupplierList.forEach(element => {
              arr.push(element.id)
            });
          }
          that.selectPrioritySupplierList = arr
        } else if(a == 0) {
          that.selectPrioritySupplierList = []
        }
        that.selectAll2Flag = !that.selectAll2Flag
      }
      that.selectAllFlag = !that.selectAllFlag
    },
    selectSupplierClickHander(){ // 选择供货商
      this.selectLabel = 1
      this.dialogTableVisible = true
      this.selectAllFlag = this.selectAll1Flag
    },
    selectSupplierChangeHandler(e){
      if(e && e.length > 0){
        // this.selectSystemFlag = false
        //
        for(var i=this.selectPrioritySupplierList.length-1; i>=0;i--){
          if(e.indexOf(this.selectPrioritySupplierList[i]) <=-1){
            this.selectPrioritySupplierList.splice(i, 1); 
          }
        }
      }
    },
    selectPrioritySupplierClickHander(){ // 选择优先供货商
      const that = this
      this.selectLabel = 2
      this.dialogTableVisible = true
      this.selectAllFlag = this.selectAll2Flag
      var arr=[]
      that.dataSupplierList.forEach(element => {
        if (that.selectSupplierList && that.selectSupplierList.length > 0){
          if(that.selectSupplierList.indexOf(element.id) > -1){
            arr.push(element)
          }
        } else {
          arr.push(element)
        }
      });
      this.dataPrioritySupplierList = arr
    },
    selectSystemChangeHander(e){ // 选择系统库
      this.dialogTableVisible = false
      if(e){
        this.dataPrioritySupplierList = []
        this.selectSupplierList = []
        this.selectPrioritySupplierList = []
        this.selectAllFlag = true
        this.selectAll1Flag = true
        this.selectAll2Flag = true
      }
    },
    // onCommitSelect(){
    //   this.dialogTableVisible = false
    //   // if(this.selectLabel === 1) {
    //     if(this.selectSupplierList && this.selectSupplierList.length > 0){
    //       this.selectPrioritySupplierDisabled = false
    //     }
    //   // }
    // },

    // 选择文件，修改当前文件列表长度后
    changeFileLength(singleFile, fileList){
      // console.log('修改当前文件', singleFile, fileList)
      this.filesLength = fileList.length
      this.BSfileList = fileList
      if(fileList.length > 0){
        this.uploadFileBtnFlag = false
      }else{
        this.uploadFileBtnFlag = true
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadOk(val) { // 调用上传接口
      // console.log("uploadOk===",val);
      const that = this
      if(!that.selectSystemFlag && that.selectSupplierList.length <= 0){
        that.$message.error("请选择供货商或者系统库！");
        return false;
      }
      that.setTimer(0);
      that.loading = true;
      this.searchEnd = false;
      that.errPage.pageTotal = 0
      that.pageTotal = 0
      that.tableData = []
      that.tableData1 = []
      that.searchWHList = []
      that.uploadFileBtnFlag = true
      that.selectFileBtnFlag = true
      let fd = new FormData();
      fd.append("searchType", that.searchType);
      fd.append("whGroups", that.whGroups.join(","));
      fd.append("productNumGe", that.productNumGe); 
      fd.append("productNumBuff", that.productNumBuff); 
      fd.append("warehouseUserId", that.$store.state.userInfo.id);
      fd.append("productSource", that.selectSystemFlag ? '0' : '1');
      // if(!that.selectSystemFlag){
        fd.append("selectSuppliers", that.selectSupplierList.join(","));
        fd.append("prioritySuppliers", that.selectPrioritySupplierList.join(","));
      // }
      fd.append("file", val.file);
      that.currentPage = 1
      var url = that.url.matchWHProductExeclByAync
        postAction(url, fd).then((res) => {
          // console.log("uploadOk-res :>> ", res);
          that.handleUploadSuccess(res, 0)
        });
    },
    handleUploadSuccess(res, a) {
      const that = this
      console.log(a);
      // console.log("handleUploadSuccess-res :>> ", a, res);
      that.filesLength = 0
      that.BSfileList = []
      that.uploadFileBtnFlag = true
      that.selectFileBtnFlag = false
      that.batchMesageList = []
      if (res.data.success) {
        that.setBatchMessage(res.data.message, 0)

        that.$message.success(res.data.message);
        that.matchingInfo = res.data.resultOther.matchingInfo
        that.batchNumber = res.data.resultOther.batchNumber
        // // 失败的信息
        // that.errorAllList = res.data.resultOther.error;
        // // 失败的信息分页
        // that.tableData1 = res.data.resultOther.errorPageRecords;
        // that.errPage.pageTotal = res.data.resultOther.errorPageTotal;
        
        // that.pageTotal = res.data.result ? res.data.result.total : 0;
        // if(a == 1){
        //   // 累加数组
        //   that.tableData = that.tableData.concat(res.data.result.records)
        // } else {
        //   // 覆盖数组
        //   that.tableData = res.data.result ? res.data.result.records: [];
        //   if(res.data.resultOther.searchWHExeclList && res.data.resultOther.searchWHExeclList.length > 0){
        //     that.searchWHList = res.data.resultOther.searchWHExeclList;
        //   }
        // }
        // 获取信息 开启定时器
        that.setTimer(1);
      } else {
        that.$message.warning("暂未匹配到您所要找的图书！");
      }
      that.loading = false;
      that.$refs.upload.clearFiles();
    },
    matchProductAuto() {
      // console.log("matchProduct===");
      this.$store.commit("hasLogin");
      if (this.isNaName) {
        this.tologin1();
      }
      this.$refs.upload.submit();
    },
    setTimer(a){
      console.log('111111111111111', a);
      // const that = this
      // clearInterval(that.timerObj)
      // if(a === 1){
      //   that.setBatchMessage("系统正在匹配...", 1)
      //   that.getBatchOrder()
      //   that.timerObj = setInterval(function(){
      //     that.getBatchOrder()
      //   }, 1000 * 10); // 10秒钟一次
      // }
    },
    getBatchOrder(){
      this.handleCurrentErrorChange(this.errPage.currentPage);
      this.handleCurrentChange(this.currentPage);
    },
    matchProductAutoTwo() {
      this.matchProductTwo()
    },
    matchProductTwo() {
      // console.log("matchProduct===");
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
        return false;
      }
      if(!that.selectSystemFlag && that.selectSupplierList.length <= 0){
        that.$message.error("请选择供货商或者系统库！");
        return false;
      }
      that.loading = true
      
      that.errPage.currentPage = 1
      that.errPage.pageTotal = 0
      
      that.currentPage = 1
      that.pageTotal = 0

      that.tableData = []
      that.tableData1 = []
      var url = that.url.matchWHProductJson
      postAction(url, {
        warehouseUserId: that.$store.state.userInfo.id,
        productSource: that.selectSystemFlag ? '0' : '1',
        selectSuppliers: that.selectSupplierList.join(","),
        prioritySuppliers: that.selectPrioritySupplierList.join(","),
        whGroups: that.whGroups.join(","),
        productNumGe: that.productNumGe,
        searchType: that.searchType,
        batchNumber: that.batchNumber,
        searchJsonArrayData: JSON.stringify(that.searchWHList),
      }).then((res) => {
        // console.log("matchProductTwo-res :>> ", res);
        that.handleUploadSuccess(res, 0)
      });
    },
    matchProductAllExport(){
      const that = this
      let fileName = this.$store.state.userInfo.warehouseName + '-批量下单-';
      downFile(that.url.matchWHProductExport, {
        warehouseUserId: that.$store.state.userInfo.id,
        whGroups: that.whGroups.join(","),
        productNumGe: that.productNumGe,
        batchNumber: that.batchNumber,
        matchingId: that.matchingInfo ? that.matchingInfo.id : '',
        searchType: that.searchType,
        productSource: that.selectSystemFlag ? '0' : '1',
        // searchJsonArrayData: JSON.stringify(that.searchWHList),
      }).then((data) => {
        that.loading = false;
        // console.log("data :>> ", data);
        if(data && data.data && data.data.size > 0){
          that.$message.success('查找数据完成，导出Zip文件...')
          let url = window.URL.createObjectURL(new Blob([data.data]))
          let a = document.createElement('a')
          // 保留原文件名
          const contentDisposition = data.headers['content-disposition'];
          if (contentDisposition) {
            let fileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
            if(!fileNameMatch){
              fileNameMatch = contentDisposition.match(/filename="?([^;"\n]+)"?/i);
            }
            if (fileNameMatch.length > 1) {
              fileName = fileNameMatch[1];
              // 如果有编码格式（比如UTF-8），需要解码
              if (fileName.startsWith("UTF-8''")) {
                  fileName = decodeURIComponent(fileName.replace("UTF-8''", ""));
              }else{
                fileName = decodeURIComponent(fileName);
              }
            }
          }else{
            let nowD = new Date()
            let contentType = data.headers['content-type'];
            let ext = "xlsx";
            if (contentType.indexOf("application/zip") > -1) {
              ext = "zip";
            }
            fileName = fileName + nowD.getFullYear() + '-' + (nowD.getMonth() + 1) + '-' + nowD.getDate() + '.' + ext;
          }

          a.setAttribute('download', fileName)
          a.href = url
          a.click()
        } else {
          that.$message.warning('数据文件失效，导出失败，请重新匹配后再导出...')
        }
      });
    },
    handleCurrentErrorChange(val) { // 分页切换
      // console.log("val------ :>> ", val);
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
        return false
      }
      this.errPage.currentPage = val;
      var url = that.url.matchWHProductErrorDataPage + "?pageNo="+that.errPage.currentPage+"&pageSize="+that.errPage.pagesize
      postAction(url, {
        warehouseUserId: that.$store.state.userInfo.id,
        opeartionUid: that.$store.state.userInfo.id,
        batchNumber: that.batchNumber,
        searchType: that.searchType,
      }).then((res) => {
        // console.log("handleCurrentErrorChange-res :>> ", res);
        that.errPage.pageTotal = res.data.result ? res.data.result.total : 0;
        // 覆盖数组
        that.tableData1 = res.data.result.records;
        if(that.tableData1 && that.tableData1.length > 0){
          that.setTimer(0);
        }
        that.setBatchMessage("匹配失败 " + that.errPage.pageTotal +" 条", 2)
        that.searchType = res.data.resultOther.searchType
        if(res.data.resultOther.searchWHExeclList && res.data.resultOther.searchWHExeclList.length > 0){
          that.searchWHList = res.data.resultOther.searchWHExeclList;
        }
      });
    },
    handleCurrentChange(val) { // 分页切换
      // console.log("val------ :>> ", val);
      // console.log("matchProduct===");
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
        return false
      }
      that.loading = true;
      this.currentPage = val;
      var url = that.url.matchWHProductSuccessDataPage + "?pageNo="+that.currentPage+"&pageSize="+that.pagesize
      postAction(url, {
        warehouseUserId: that.$store.state.userInfo.id,
        opeartionUid: that.$store.state.userInfo.id,
        whGroups: that.whGroups.join(","),
        productNumGe: that.productNumGe,
        batchNumber: that.batchNumber,
        searchType: that.searchType,
        productSource: that.selectSystemFlag ? '0' : '1',
        selectSuppliers: that.selectSupplierList.join(","),
        prioritySuppliers: that.selectPrioritySupplierList.join(","),
        searchJsonArrayData: JSON.stringify(that.searchWHList),
      }).then((res) => {
        that.loading = false;
        // console.log("handleCurrentChange-res :>> ", res);
        that.pageTotal = res.data.result ? res.data.result.total : 0;
        // 覆盖数组
        that.tableData = res.data.result.records;
        if(that.tableData && that.tableData.length > 0){
          that.setTimer(0);
        }
        that.setBatchMessage("匹配成功 " + that.pageTotal +" 条", 3)
        that.searchType = res.data.resultOther.searchType
        if(res.data.resultOther.searchWHExeclList && res.data.resultOther.searchWHExeclList.length > 0){
          that.searchWHList = res.data.resultOther.searchWHExeclList;
        }
      });
    },
    handleSelectionChange(val) {
      this.selectProductList = val;
    },
    //加入购物车
    addCartAll() {
      // console.log("addCartAll======", this.tableData.length);
      this.addCart(this.tableData,'all');
    },
    addCartSelect(){
      this.addCart(this.selectProductList,'select');
    },
    addCart(rowList, addFlag) {
      console.log("addCart==",addFlag, rowList.length);
      const that = this;
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
      }
      if(rowList.length == 0){
        that.$message({message: "未选择图书！", type: "warning",});
        return;
      }
      let storeCartWHList = that.$store.state.shopWHCart
        // console.log('addCart', rowList)
        // console.log('listCart', storeCartWHList)

      let params = [];
      for (let i = 0; i < rowList.length; i++) {
        var sp = rowList[i]
        if(sp.buyNum > 0 && sp.productNum > 0){
          // 校验库存是否已超过真实库存。
          if (storeCartWHList && storeCartWHList.length > 0) {
            for (let j = 0; j < storeCartWHList.length; j++) {
              let cartObj = storeCartWHList[j]
              if(cartObj 
                && cartObj.productStockId === sp.id
                && (cartObj.productNumber + sp.buyNum) > sp.productNum
              ){
                that.$message.error(sp.productName + " 加购的图书数量(包括购物车中的)大于当前库存");
                return false
              }
            }
          }
          let proParams = {};
          proParams.productStockId =  rowList[i].id
          proParams.productSource = rowList[i].productSource
          proParams.productNumber = rowList[i].buyNum
          params.push(proParams);
        }
      }
      // console.log('1111111', params)
      let user_id = that.$store.state.userInfo.id;
      postAction(that.url.addWHCart, {
        params: JSON.stringify(params),
        whUId: user_id,
      }).then((res) => {
        if (res.data.success) {
          that.getCartItems();
          that.$message({message: "加入购物车成功！",type: "success",});
        }
      });
    },
    getCartItems() {
      //获取购物车信息,并存入vuex
      getAction(this.url.queryCartWHList, {
        whUId: this.$store.state.userInfo.id,
      }).then((ret) => {
        if (ret.data.success) {
          this.$store.state.shopWHCart = ret.data.result;
          window.sessionStorage.setItem("shopWHCart",JSON.stringify(ret.data.result));
        }
      });
    },
    getDataSupplierList(){ // 供应商导入的供货商信息列表
      getAction(this.url.queryWHCustomerSupplierList, {
        whUId: this.$store.state.userInfo.id,
      }).then((ret) => {
        if (ret.data.success) {
          this.dataSupplierList = ret.data.result
        }
      });
    },
    setBatchMessage(msg, a){
      console
      const that = this
      if(a == 0){
        that.batchMesageList = []
      }
      if(a == 2 || a == 3){
        if(that.tableData.length == 0 && that.tableData1.length == 0){
          return false;
        }
      }
      that.batchMesageList[a] = msg
    },
    tologin1() {
      this.$message({
        message: "请登录供应商身份账号！",
        type: "warning",
      });
      this.$router.push("/loginProvider");
    },
  },
};
</script>
<style lang="scss" scoped>
.clearfix>h1 {
  font-size: 18px;
  color: #333;
}
.grid-content>span,.clearfix>span{
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.el-progress {
  width: 50%;
  line-height: 3;
  margin-left: 15px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
</style>
